<button (click)="openCreate()" class="btn btn-primary-outline add-button">Add</button>
<h4>Store Closed</h4>
<table class="table">
  @for (closedDay of storeClosures(); track closedDay) {
    <tr>
      <td>{{ closedDay.startDate }}</td>
      <td>{{ closedDay.reason }}</td>
      <td>
        @if (canEditAtDate(closedDay.startDate)) {
          <i
                  (click)="openUpdate(closedDay)"
                  class="fa fa-xs fa-pen pointer me-1">
          </i>
        }
        @if (canEditAtDate(closedDay.startDate)) {
          <i
                  (click)="openDelete(closedDay.startDate)"
                  class="fa fa-xs fa-trash pointer">
          </i>
        }
      </td>
    </tr>
  }
</table>